var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityGrid } from './entity-grid';
import { reverse, pickBy, size, sortBy, intersection, first, keys, map, get } from 'lodash';
import { TabsContainer } from '../elements/tabs-container';
import { Tab } from '../elements/tab';
import { useAvailableEntities } from '../context/available-entities-context';
import { useLink } from '../hooks/use-link';
import { useLang } from '../hooks/use-lang';
import pluralize from 'pluralize';
import { sprintf } from 'sprintf-js';
import { useKnowledgeHubState } from '../context/knowledge-hub-state-context';
import { useReady } from '../hooks/use-ready';
import { useTopics } from '../hooks/use-topics';
import { useSubTopics } from '../hooks/use-sub-topics';
import { useCitations } from '../hooks/use-citations';
import { useFeedEntries } from '../hooks/use-feed-entries';
import { usePosts } from '../hooks/use-posts';
import { useTrends } from '../hooks/use-trends';
import { useVideos } from '../hooks/use-videos';
var cls = classNames('page-knowledge-hub-layout');
// TO_DO - migrate filters to this component. ItemsPerPage prop in EntityGrid affects filters as items are limited, so in turn, not all filters show up.
var ENTITY_SORT_BY = {
  Post: 'published'
};
export var PageKnowledgeHubLayoutDefaultProps = {
  tabProps: {},
  showAllTab: true,
  allTabLabel: 'Latest',
  entityTypes: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TabsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: 64px;\n  "], ["\n    min-height: 64px;\n  "])))
});
var TabStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    // TODO - adapt to font system\n    font-family: ", ";\n    font-size: 1em;\n    ", "\n\n    &:last-child {\n      border-right: none;\n    }\n  "], ["\n    // TODO - adapt to font system\n    font-family: ", ";\n    font-size: 1em;\n    ", "\n\n    &:last-child {\n      border-right: none;\n    }\n  "])), theme.FONT('serif'), function (_a) {
    var tabCount = _a.tabCount;
    return tabCount !== 0 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex-basis: ", "%;\n    "], ["\n      flex-basis: ", "%;\n    "])), 100 / tabCount);
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(3))
});
var LatestEntityStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    padding-left: ", ";\n    font-weight: 400;\n  "], ["\n    color: ", ";\n    padding-left: ", ";\n    font-weight: 400;\n  "])), theme.COLOR('strong'), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  TabsContainer: styled(TabsContainer)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: styled(Tab)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TabStyles),
  LatestEntity: styled.div.attrs(cls.attr('latest-entity'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LatestEntityStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Grid: styled(EntityGrid)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
export var PageKnowledgeHubLayout = function (props) {
  var className = props.className,
    slices = props.slices,
    tabProps = props.tabProps,
    filterSize = props.filterSize,
    filterSpacing = props.filterSpacing,
    allTabLabel = props.allTabLabel;
  var activeEntityTypeName = '';
  if (typeof document !== 'undefined') {
    activeEntityTypeName = document.location.hash && document.location.hash.replace(/^#/, '');
  }
  var _a = __read(useKnowledgeHubState(), 3),
    state = _a[0],
    setState = _a[1],
    patchState = _a[2];
  var availableEntities = useAvailableEntities();
  var prepareEntity = function (entityTypeName, items) {
    if (items === void 0) {
      items = [];
    }
    var sortByField = get(props.entityTypes, "".concat(entityTypeName, ".sortBy"), ENTITY_SORT_BY[entityTypeName] || 'updated');
    var isReverse = get(props.entityTypes, "".concat(entityTypeName, ".reverse"), true);
    return isReverse ? reverse(sortBy(items, sortByField)) : sortBy(items, sortByField);
  };
  var providedEntities = {
    FeedEntry: prepareEntity('FeedEntry', useFeedEntries()),
    Post: prepareEntity('Post', usePosts()),
    Video: prepareEntity('Video', useVideos()),
    Citation: prepareEntity('Citation', useCitations()),
    Trend: prepareEntity('Trend', useTrends()),
    Topic: prepareEntity('Topic', useTopics()),
    SubTopic: prepareEntity('SubTopic', useSubTopics()),
    FileAsset: prepareEntity('FileAsset', []),
    Guidebook: prepareEntity('Guidebook', []),
    CaseStudy: prepareEntity('CaseStudy', []),
    Entity: prepareEntity('Entity', [])
  };
  var navigate = useLink().navigate;
  var t = useLang();
  var entityTypeKeys = keys(props.entityTypes);
  var entityTypeNamesSelected = !!entityTypeKeys.length && entityTypeKeys || props.entityTypeNames && !!props.entityTypeNames.length && props.entityTypeNames || availableEntities || [];
  var isReady = useReady().isReady;
  // no point showing the all tab if there is only one type of entity
  var showTabs = entityTypeNamesSelected.length > 1 && isReady;
  var showAllTab = showTabs && props.showAllTab;
  var entityTypes = intersection(entityTypeNamesSelected, availableEntities).reduce(function (acc, entityTypeName) {
    var _a;
    var entityTypeProps = props.entityTypes[entityTypeName] || {};
    var pluralLabel = entityTypeProps.label || pluralize.plural(entityTypeName);
    return __assign(__assign({}, acc), (_a = {}, _a[entityTypeName] = __assign({
      latestCount: 3,
      latestTitle: sprintf(t('Latest %s'), pluralLabel),
      items: providedEntities[entityTypeName] || [],
      label: sprintf(t('All %s'), pluralLabel)
    }, entityTypeProps), _a));
  }, {});
  var nonEmptyEntityTypes = pickBy(entityTypes, function (entityType) {
    return !!entityType.items.length;
  });
  var nonEmptyEntityCount = size(nonEmptyEntityTypes);
  var tabCount = nonEmptyEntityCount + (showAllTab ? 1 : 0);
  if (nonEmptyEntityCount <= 1 || !showAllTab && activeEntityTypeName === '') {
    activeEntityTypeName = first(keys(nonEmptyEntityTypes)) || '';
  }
  var onFilterValuesChange = function (values) {
    // console.log(values, activeEntityTypeName);
    var _a;
    if (activeEntityTypeName) {
      var newState = __assign(__assign({}, state), (_a = {}, _a[activeEntityTypeName] = __assign(__assign({}, state[activeEntityTypeName] || {}), {
        filters: values
      }), _a));
      // console.log("NEW STATE", newState);
      setState(newState);
    }
  };
  // @ts-ignore
  var activeEntityType = entityTypes[activeEntityTypeName];
  var activeEntityFilterValues = state && state[activeEntityTypeName] && state[activeEntityTypeName].filters || {};
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, slices, nonEmptyEntityCount > 1 && React.createElement(My.TabsContainer, null, showTabs && React.createElement(React.Fragment, null, showAllTab && React.createElement(My.Tab, __assign({}, tabProps, {
    tabCount: tabCount,
    isActive: activeEntityTypeName === '',
    onClick: function () {
      document.location.hash = '';
    }
  }), t(allTabLabel)), map(entityTypes, function (config, entityTypeName) {
    return React.createElement(My.Tab, __assign({}, tabProps, {
      tabCount: tabCount,
      isActive: activeEntityTypeName === entityTypeName,
      key: entityTypeName,
      onClick: function () {
        document.location.hash = entityTypeName;
      }
    }), t(config.label));
  }))), React.createElement(My.Body, null, showAllTab && activeEntityTypeName === '' && map(entityTypes, function (config, entityTypeName) {
    var items = (config.items && config.latestCount ? config.items.slice(0, config.latestCount) : config.items) || [];
    if (items.length) {
      return React.createElement(My.LatestEntity, {
        key: "latest-".concat(entityTypeName)
      }, React.createElement(My.Title, null, config.latestTitle), React.createElement(My.Grid, {
        spacing: config.spacing,
        items: items,
        anyCardProps: {
          variant: 'chromeless'
        },
        card: config.cardComponent,
        descriptionMaxLines: config.descriptionMaxLines,
        desktopFullHdAutoColumns: 3,
        desktopLargeAutoColumns: 3
      }));
    }
    return null;
  }), activeEntityType && React.createElement(My.Grid, {
    filterSize: filterSize,
    filterSpacing: filterSpacing,
    spacing: activeEntityType.spacing,
    filterValues: activeEntityFilterValues,
    anyCardProps: {
      variant: 'chromeless'
    },
    onFilterValuesChange: onFilterValuesChange,
    filterFieldNames: activeEntityType.filterFieldNames,
    toggleTypes: activeEntityType.toggleTypes,
    descriptionMaxLines: activeEntityType.descriptionMaxLines,
    items: activeEntityType.items,
    card: activeEntityType.cardComponent,
    desktopFullHdAutoColumns: 3,
    desktopLargeAutoColumns: 3,
    desktopAutoColumns: 3,
    tabletAutoColumns: 2,
    landscapeAutoColumns: 1
  })));
};
PageKnowledgeHubLayout.defaultProps = PageKnowledgeHubLayoutDefaultProps;
PageKnowledgeHubLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;